import { baseApi } from "./api";

export const projectPermissionPresetsApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		listPresets: build.query({
			query: (projectId) => ({
				url: `projects/${projectId}/permission-presets`,
			}),
			providesTags: (_result, _error, projectId) => [
				{ type: "PermissionPreset", id: projectId },
				// Global tag so admin system-template mutations (a different
				// service, same baseApi) can invalidate every project's list.
				{ type: "PermissionPreset", id: "LIST" },
			],
		}),
		listPresetsByType: build.query({
			query: ({ projectId, type }) => ({
				url: `projects/${projectId}/permission-presets`,
				params: type ? { type } : undefined,
			}),
			providesTags: (_result, _error, { projectId }) => [
				{ type: "PermissionPreset", id: projectId },
				{ type: "PermissionPreset", id: "LIST" },
			],
		}),
		createPreset: build.mutation({
			query: ({ projectId, ...body }) => ({
				url: `projects/${projectId}/permission-presets`,
				method: "POST",
				body,
			}),
			invalidatesTags: (_result, _error, { projectId }) => [
				{ type: "PermissionPreset", id: projectId },
			],
		}),
		updatePreset: build.mutation({
			query: ({ projectId, id, ...body }) => ({
				url: `projects/${projectId}/permission-presets/${id}`,
				method: "PUT",
				body,
			}),
			invalidatesTags: (_result, _error, { projectId }) => [
				{ type: "PermissionPreset", id: projectId },
			],
		}),
		deletePreset: build.mutation({
			query: ({ projectId, id }) => ({
				url: `projects/${projectId}/permission-presets/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: (_result, _error, { projectId }) => [
				{ type: "PermissionPreset", id: projectId },
			],
		}),
	}),
});

export const {
	useListPresetsQuery,
	useListPresetsByTypeQuery,
	useCreatePresetMutation,
	useUpdatePresetMutation,
	useDeletePresetMutation,
} = projectPermissionPresetsApi;
